import { useLingui } from '@lingui/react/macro'
import { Accordion, AccordionItem } from 'components/Accordion'
import {
  DataSmoothing,
  RegressionPrediction,
  ThresholdFiltering,
  useScatterplotContext,
} from 'features/timeSeries'
import { Filter, LineChart, TrendingUp } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const AccordionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.725rem;
  font-weight: 500;
  text-transform: uppercase;
`

const Wrapper = styled.div`
  width: 100%;
`

export const DataProcessingToolbar: React.FC = () => {
  const { t } = useLingui()
  const { selectedSensors, sensorEntries } = useScatterplotContext()

  const accordionItems: AccordionItem[] = [
    {
      key: 'threshold-filtering',
      title: (
        <AccordionTitle>
          <Filter size={14} />
          {t`Threshold Filtering`}
        </AccordionTitle>
      ),
      content: (
        <ThresholdFiltering
          selectedSensors={selectedSensors}
          sensorEntries={sensorEntries}
        />
      ),
    },
    {
      key: 'data-smoothing',
      title: (
        <AccordionTitle>
          <LineChart size={14} />
          {t`Data Smoothing`}
        </AccordionTitle>
      ),
      content: (
        <DataSmoothing
          selectedSensors={selectedSensors}
          sensorEntries={sensorEntries}
        />
      ),
    },
    {
      key: 'regression-prediction',
      title: (
        <AccordionTitle>
          <TrendingUp size={14} />
          {t`Regression & Prediction`}
        </AccordionTitle>
      ),
      content: (
        <RegressionPrediction
          selectedSensors={selectedSensors}
          sensorEntries={sensorEntries}
        />
      ),
    },
  ]

  return (
    <Wrapper>
      <Accordion items={accordionItems} defaultValue={[]} />
    </Wrapper>
  )
}
